<style scoped>
@import url("../../assets/sanger.css");
</style>
<style scoped>
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<template>
  <div class="wrap wrap-tec wrap-tec1">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/zl_bg.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>全质粒测序</h1>-->
<!--          <h2 class="mt10">Whole plasmid sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>全质粒测序</h1>
      <h2 class="mt10">Whole Plasmid Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">全质粒测序，是指基于第二代高通量测序技术，对质粒的全基因组进行建库测序，利用生物信息分析手段，对测序数据进行测序深度、GC 含量以及质粒全序列组装分析。</p>
      <div class="c-title">服务类型</div>
      <table class="table">
        <tr>
          <th style="width: 150px">质粒大小</th>
          <th style="width: 200px">测序深度（GB）</th>
          <th style="width: 200px">交付结果</th>
          <th style="width: 200px">交付周期 （自然日）</th>
          <th style="width: 200px">价格（元/样品）</th>
        </tr>
        <tr>
          <td>＜5kb</td>
          <td rowspan="5">＞30</td>
          <td  rowspan="5">
            1.全序列<br>
            2.结果参数报告
          </td>
          <td  rowspan="5">10天</td>
          <td>68</td>
        </tr>
        <tr>
          <td>5kb-15kb</td>
          <td>168</td>
        </tr>
        <tr>
          <td>15kb-30kb</td>
          <td>198</td>
        </tr>
        <tr>
          <td>30kb-60kb</td>
          <td>398</td>
        </tr>
        <tr>
          <td>＞60kb</td>
          <td>询价</td>
        </tr>
      </table>
      <div class="yingyong">
        <div class="c-title">应用领域</div>
        <ul class="lists area">
          <li>
            <img src="@/assets/images/zl_yy1.png">
            <p>未知质粒测序</p>
          </li>
          <li>
            <img src="@/assets/images/zl_yy2.png">
            <p>质粒功能研究</p>
          </li>
          <li>
            <img src="@/assets/images/zl_yy3.png">
            <p>BAC克隆子测序</p>
          </li>
        </ul>
      </div>
      <div class="c-title">技术路线</div>
      <div class="tc"><img src="@/assets/images/zl_keji.png"> </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/Whole_plasmid.vue